import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const WhatsAppFab = () => {
  return (
    <motion.a
      href="https://wa.me/491234567890" // Placeholder number
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      whileHover={{ scale: 1.1 }}
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-[0_4px_20px_rgba(37,211,102,0.4)] flex items-center justify-center group"
    >
      <SafeIcon name="MessageCircle" className="text-2xl" />
      <span className="absolute right-full mr-4 bg-dark text-cream text-sm px-4 py-2 rounded-md whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity border border-white/10 pointer-events-none">
        Direkt via WhatsApp schreiben
      </span>
    </motion.a>
  );
};

export default WhatsAppFab;